// extracted by mini-css-extract-plugin
module.exports = {"emailSentText":"ResetPasswordSuccessScreen_emailSentText__1SLtT"};